import { render } from "./Project-4.vue?vue&type=template&id=622832f3"
import script from "./Project-4.vue?vue&type=script&lang=js"
export * from "./Project-4.vue?vue&type=script&lang=js"
script.render = render

export default script